module.exports = __webpack_public_path__ + "img/box1.89f27e3b.png";